import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useTrainingFormState from './useTrainingFormState'
import TrainingContentSection from './TrainingContentSection'
import TrainingDetailsSection from './TrainingDetailsSection'
import TrainingLocationSection from './TrainingLocationSection'

export default function TrainingForm({
	initialData,
	onSubmit,
	onCancel,
	submitting = false,
	mode = 'add',
	certificationOptions = [],
	trainingNameOptions = [],
	contentOptions = [],
}) {
	const { t } = useTranslation()
	const [showTrainingNameError, setShowTrainingNameError] = useState(false)
	const isEditMode = mode === 'edit'
	const { form, setForm, setField } = useTrainingFormState(initialData)

	useEffect(() => {
		setShowTrainingNameError(false)
	}, [initialData])

	const handleSubmit = e => {
		e.preventDefault()
		if (!`${form.nazwa || ''}`.trim()) {
			setShowTrainingNameError(true)
			return
		}
		onSubmit(form)
	}

	const submitLabel = isEditMode ? t('trainings.edit.submit') : t('trainings.add.submit')
	const submittingLabel = isEditMode ? t('trainings.edit.submitting') : t('trainings.add.submitting')
	const cancelLabel = isEditMode ? t('trainings.edit.cancel') : t('trainings.add.cancel')

	return (
		<form className="space-y-6" onSubmit={handleSubmit}>
			<TrainingDetailsSection
				form={form}
				setField={setField}
				setForm={setForm}
				certificationOptions={certificationOptions}
				trainingNameOptions={trainingNameOptions}
				showTrainingNameError={showTrainingNameError}
				onTrainingNameErrorClear={() => setShowTrainingNameError(false)}
			/>

			<TrainingLocationSection
				form={form}
				onChange={updates => setForm(prev => ({ ...prev, ...updates }))}
			/>

			<TrainingContentSection
				form={form}
				setField={setField}
				contentOptions={contentOptions}
			/>

			<label className="flex flex-col gap-1">
				<span className="text-sm font-medium text-gray-700">{t('trainings.form.fields.remarks')}</span>
				<textarea
					className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
					rows={4}
					value={form.remarks}
					onChange={e => setField('remarks', e.target.value)}
				/>
			</label>

			<div className="flex justify-end gap-3 border-t border-gray-200 pt-4">
				<button
					type="submit"
					disabled={submitting}
					className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
				>
					{submitting ? submittingLabel : submitLabel}
				</button>
				{onCancel ? (
					<button
						type="button"
						onClick={onCancel}
						className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50"
					>
						{cancelLabel}
					</button>
				) : null}
			</div>
		</form>
	)
}
